module.exports = "/ceaea34bef4df09a7ee52cae7c73ce09.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/feature-2.png
 ** module id = 2212
 ** module chunks = 0
 **/